import { render, staticRenderFns } from "./CouponListDefaultLayout.vue?vue&type=template&id=6569bcd1&scoped=true"
import script from "./CouponListDefaultLayout.vue?vue&type=script&lang=js"
export * from "./CouponListDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6569bcd1",
  null
  
)

export default component.exports